/* Spanish catalog mirroring locale-inbox-vouchers-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'voucher.none': 'Sin justificantes',
  'voucher.noLedgerLines': 'Todavía no hay líneas del libro mayor disponibles desde el backend.',
  'voucher.noLedger': 'Sin líneas del libro mayor',
  'voucher.action': 'Acción',
  'voucher.title': 'Transacciones',
  'voucher.incompleteBasis': 'La cobertura del diario es incompleta. La lista sigue disponible para buscar documentos, pero no debe tratarse como un libro mayor ni una lista de justificantes completos.',
  'voucher.subtitle': 'Todas las transacciones contabilizadas del ejercicio fiscal',
  'voucher.backToVat': 'Volver a la declaración de IVA',
  'voucher.showAll': 'Mostrar todas las transacciones',
  'voucher.download': 'Descargar',
  'voucher.loadingPreview': 'Cargando vista previa...',
  'voucher.cannotPreviewUse': 'El archivo no se puede previsualizar aquí. Usa Descargar cuando quieras abrirlo.',
  'voucher.cannotPreview': 'Este tipo de archivo no se puede previsualizar aquí.',
  'voucher.invoice': 'Factura',
  'voucher.voucher': 'Justificante',
  'voucher.attachmentAttached': 'Justificante adjunto',
  'voucher.commentOptional': 'Comentario (opcional)',
  'voucher.commentPh': 'Por ejemplo: importe incorrecto, asiento duplicado o proveedor equivocado.',
  'voucher.view': 'Vista',
  'voucher.viewHelp': 'Cambia entre la lista de justificantes, los asientos detallados y el libro mayor agrupado por cuenta.',
  'voucher.view.bilag': 'Justificantes',
  'voucher.view.detaljer': 'Detalles',
  'voucher.view.hovedbok': 'Libro mayor',
  'voucher.searchPh': 'Buscar por justificante, cuenta o importe',
  'voucher.searchHelp': 'Busca por número de justificante, contraparte, cuenta/asiento o importe. En la vista del libro mayor también puedes buscar por debe, haber y saldo.',
  'voucher.filterHelp': 'Filtra los justificantes por tipo, adjunto, estado de pago, periodo e importe.',
  'voucher.amountTitle': 'Importe del justificante',
  'voucher.amountHelp': 'Neto es el importe sin IVA (el gasto o ingreso en sí), IVA es el impuesto y bruto es el total con IVA. Junto con la fecha y el número de justificante, son los datos clave del asiento.',
  'voucher.rowHelp': 'Cada fila es un justificante. El icono y la etiqueta muestran el tipo (venta, compra, factura de proveedor, nota de crédito, justificante manual), y ves el nombre y el número de justificante. Toca la fila para abrir el justificante.',
  'voucher.net': 'Neto',
  'voucher.netHelp': 'El importe sin IVA: el gasto o ingreso en sí que se contabiliza en una cuenta.',
  'voucher.vat': 'IVA',
  'voucher.vatHelp': 'El IVA del justificante: IVA repercutido en las ventas, IVA soportado (deducible) en las compras.',
  'voucher.gross': 'Bruto',
  'voucher.totalAmount': 'Importe total',
  'voucher.grossHelp': 'El total con IVA: neto más IVA. Es el importe realmente pagado o recibido.',
  'voucher.accountPh': 'Por ejemplo: software, banco o 6300',
  'voucher.account': 'Cuenta',
  'voucher.accountHelp': 'La cuenta indica para qué es el asiento, tomada del plan de cuentas. El número de cuenta decide dónde acaba el importe (1xxx activos, 2xxx pasivos/patrimonio, 3xxx ingresos, 4-7xxx gastos). Toca el icono de lista para buscar en el plan de cuentas.',
  'voucher.pickAccount': 'Elegir cuenta',
  'voucher.searchChart': 'Buscar en el plan de cuentas...',
  'voucher.noDescription': 'Sin descripción',
  'voucher.removeEntry': 'Eliminar asiento',
  'voucher.entryDate': 'Fecha del justificante',
  'voucher.entryDateHelp': 'La fecha en la que debe contabilizarse el asiento. Decide en qué periodo contable y de IVA queda el asiento.',
  'voucher.whatFor': '¿Para qué es el asiento?',
  'voucher.whatForHelp': 'Un texto breve que explica para qué es el asiento. Aparece en el libro mayor y facilita entenderlo más adelante.',
  'voucher.fromAccount': 'Cuenta de origen',
  'voucher.toAccount': 'Cuenta de destino',
  'voucher.fromAccountCredit': 'Cuenta de origen (haber)',
  'voucher.fromAccountHelp': 'La cuenta de la que SALE el dinero: el lado del haber del asiento. Si pagas el alquiler desde la cuenta bancaria, el banco (1920) es el "origen". Un haber reduce un activo o aumenta un pasivo/ingreso.',
  'voucher.vatCode': 'Código de IVA',
  'voucher.vatCodeHelp': 'El código de IVA controla cómo se calcula y se declara el IVA en la declaración de IVA. El código 86 se usa para servicios prestados a distancia desde el extranjero. Las importaciones de mercancías se registran mediante el flujo de declaración de aduanas.',
  'voucher.swap': 'Intercambiar origen y destino',
  'voucher.swapHelp': 'Intercambia la cuenta de origen y la de destino de la línea. Útil si has introducido el debe y el haber al revés.',
  'voucher.toAccountDebit': 'Cuenta de destino (debe)',
  'voucher.toAccountHelp': 'La cuenta a la que VA el dinero: el lado del debe del asiento. Si el asiento es por el alquiler, la cuenta de alquiler (6300) es el "destino". Un debe aumenta un gasto o un activo.',
  'voucher.addLineHelp': 'Añade una nueva línea de asiento a este justificante. Usa varias líneas cuando el importe se reparte entre cuentas: entre todas las líneas, el debe y el haber deben cuadrar a cero.',
  'voucher.attachHelp': 'Adjunta la documentación del asiento: un recibo, una factura u otro justificante. Es opcional pero recomendable: una buena documentación hace que las cuentas sean verificables. Puedes arrastrar archivos o pegar una captura de pantalla.',
  'voucher.attachOptional': 'Adjuntos (opcional)',
  'voucher.uploadAttachment': 'Subir adjunto',
  'voucher.deleteAttachment': 'Eliminar adjunto',
  'voucher.openNewTab': 'Abrir en una pestaña nueva',
  'voucher.balance': 'Saldo',
  'voucher.balanceHelp': 'Indica si el asiento cuadra. "Cuadrado" significa que el total de destino (debe) es igual al total de origen (haber); entonces se puede contabilizar el asiento. Si hay diferencia, corrige los importes para que cuadren a cero.',
  'voucher.toDebit': 'Destino (debe)',
  'voucher.fromCredit': 'Origen (haber)',
  'voucher.posted': 'Contabilizado',
  'voucher.edit': 'Editar',
  'voucher.newCopy': 'Nueva copia del asiento manual',
  'voucher.newFree': 'Nuevo asiento manual',
  'voucher.from': 'Origen',
  'voucher.to': 'Destino',
  'voucher.sum': 'Total',
  'voucher.newEntry': 'Nuevo asiento',
  'voucher.newEntryHelp': 'Añade otro asiento (un nuevo justificante) en el mismo registro. Cada asiento tiene su propia fecha, descripción y líneas, y se contabiliza como un justificante propio.',
  'voucher.postHelp': 'Contabiliza los asientos en las cuentas. El botón solo se activa cuando todos los asientos cuadran, es decir, cuando el debe y el haber suman cero.',
  'voucher.details': 'Detalles',
  'voucher.statusBalanced': 'Cuadrado',
  'voucher.statusMissingAccount': 'Falta la cuenta',
  'voucher.statusSameAccount': 'Misma cuenta',
  'voucher.statusEmpty': 'Vacío',
  'voucher.statusUnbalanced': 'Descuadrado',
  'voucher.attachDropHint': 'Arrastra y suelta archivos aquí, o pega una captura de pantalla con Ctrl+V',
  'voucher.chooseBothAccounts': 'Elige la cuenta de origen y la de destino.',
  'voucher.sameAccountWarning': 'La cuenta de origen y la de destino no pueden ser la misma.',
  'voucher.balancedReady': 'Cuadrado: listo para registrar',
  'voucher.enterAmount': 'Introduce un importe.',
  'voucher.difference': 'Diferencia: {amount}',
  'voucher.postedTitlePlural': 'Asientos registrados',
  'voucher.postedTitleSingular': 'Asiento registrado',
  'voucher.postedBodyPlural': 'Se han contabilizado {count} asientos.',
  'voucher.postedBodySingular': 'El asiento se ha contabilizado.',
  'voucher.postedIntro': 'Así se ha contabilizado:',
  'voucher.descriptionRequired': 'Introduce una descripción en todos los asientos antes de contabilizar.',
  'voucher.saveFailed': 'No se pudo registrar el asiento.',
  'voucher.backTo': 'Volver a {label}',
  'voucher.controlPoint': 'el punto de control',
  'voucher.editTitle': 'Editar asiento libre',
  'voucher.freePosting': 'Asiento libre',
  'voucher.editSubtitle': 'Actualiza el asiento y guarda los cambios en el backend.',
  'voucher.correctPostedTitle': 'Corregir justificante contabilizado',
  'voucher.correctPostedSubtitle': 'El original se conserva. Plumme contabiliza una anulación y un justificante de sustitución en una sola operación.',
  'voucher.correctPostedNotice': 'El justificante original y su número de diario no cambian. El cambio queda registrado como una anulación y una sustitución vinculadas.',
  'voucher.correctionReason': 'Motivo de la corrección',
  'voucher.correctionReasonPlaceholder': 'Describe qué estaba mal y por qué se corrige el justificante',
  'voucher.correctPostedAction': 'Corregir justificante',
  'voucher.correctionPreview': 'Vista previa de la corrección',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Anulación exacta',
  'voucher.correctionReplacement': 'Justificante de sustitución',
  'voucher.freePostingSubtitle': 'Asientos manuales: el debe y el haber deben cuadrar a cero',
  'voucher.freePostingTitleHelp': 'El asiento libre te permite contabilizar manualmente directamente en una cuenta cuando necesitas control total, por ejemplo correcciones, reclasificaciones o asientos que no encajan en una compra o venta normal. Tú eliges entre qué cuentas se mueve el importe.',
  'voucher.directVatWarningTitle': 'Aviso: asiento directo en una cuenta de IVA',
  'voucher.directVatWarningBody': 'Estos asientos se contabilizan en el libro mayor, pero quedan excluidos de la declaración de IVA. Usa el flujo normal de compra, venta o declaración de aduanas cuando el importe deba declararse como IVA.',
  'voucher.directVatExcluded': 'excluido de la declaración de IVA',
  'voucher.directVatConfirmLabel': 'Escribe OK para confirmar que entiendes la consecuencia',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Registrar asientos',
  'voucher.registerEntrySingular': 'Registrar asiento',
  'voucher.registering': 'Registrando...',
  'voucher.creditWord': 'haber',
  'voucher.debitWord': 'debe',
  'voucher.attachmentFallbackName': 'adjunto',
  'inbox.prevPage': 'Página anterior',
  'inbox.page': 'Página',
  'inbox.nextPage': 'Página siguiente',
  'inbox.zoomOut': 'Alejar',
  'inbox.zoomIn': 'Acercar',
  'inbox.rotate': 'Girar recibo',
  'inbox.mainDoc': 'Recibo principal',
  'inbox.moveTo': 'Mover a',
  'inbox.payOperating': 'Cuenta operativa - 1920',
  'inbox.payCash': 'Efectivo - 1900',
  'inbox.payPrivate': 'Gasto privado',
  'inbox.payUnknown': 'Elegir origen del pago ...',
  'inbox.suggestion': 'Sugerencia de SuperPlumma',
  'inbox.docType': 'Tipo de justificante',
  'inbox.quickChoices': 'Opciones rápidas',
  'inbox.quickChoiceUse': 'Elige qué debe reemplazar la opción rápida',
  'inbox.quickChoiceRemembered': 'Recordado de {count} justificantes anteriores del proveedor.',
  'inbox.quickChoiceAccount': 'Reemplazar cuenta',
  'inbox.quickChoiceDescription': 'Reemplazar descripción',
  'inbox.quickChoiceBoth': 'Reemplazar ambos',
  'inbox.purchase': 'Compra',
  'inbox.supplierInvoice': 'Factura de proveedor',
  'inbox.pickSupplier': 'Elegir proveedor',
  'inbox.invoiceNoPh': 'Por ejemplo: 0012345',
  'inbox.toggleVatHelp': 'Toca para cambiar si el importe que introduces es sin IVA o con IVA. Plumme lo convierte automáticamente y guarda el importe bruto en la sugerencia de justificante.',
  'inbox.vatDeductionRate': 'Deducción de IVA sugerida',
  'inbox.documentVatRateHint': 'El documento muestra un {documentRate}% de IVA. La sugerencia usa una deducción del {deductionRate}% según el estado de IVA de la empresa y el tratamiento seleccionado.',
  'inbox.accountCategory': 'Cuenta/categoría',
  'inbox.accountHelp': 'La sugerencia de SuperPlumma viene preseleccionada. Toca para elegir otra cuenta.',
  'inbox.dueDateFromReceipt': 'El documento no tiene fecha de vencimiento. Se establece la fecha del documento.',
  'inbox.supplierNotSaved': 'Selecciona un proveedor guardado, o guarda el proveedor antes de contabilizar la factura.',
  'err.purchase.supplierNotSaved': 'Selecciona un proveedor guardado, o guarda el proveedor antes de contabilizar la factura.',
  'inbox.duplicateTitle': 'Posible duplicado',
  'inbox.duplicateBody': 'Ya hay contabilizado un justificante con la misma fecha e importe.',
  'inbox.duplicateSameSupplier': 'Ya hay contabilizado un justificante con la misma fecha, importe y proveedor.',
  'inbox.duplicateUploadFile': 'Posible subida duplicada: el mismo archivo exacto ya está en la bandeja de entrada.',
  'inbox.duplicateUploadContent': 'Posible subida duplicada: mismo proveedor e importe que otro justificante de la bandeja de entrada, con fechas de justificante separadas por 7 días o menos.',
  'inbox.duplicateUploadCount': 'Afecta a otros {count} justificantes.',
  'inbox.setPaymentSource': 'Pagado desde',
  'inbox.bulkPaymentTitle': 'Pagado desde',
  'inbox.bulkPaymentLead': 'El origen se establece en {count} documentos. Después puedes cambiarlo en cada documento.',
  'inbox.bulkPaymentLabel': 'Pagado desde',
  'inbox.bulkPaymentHint': 'Los documentos quedan listos para contabilizar con esta cuenta.',
  'inbox.bulkPaymentPick': 'Elige primero un origen de pago.',
  'inbox.bulkPaymentConfirm': 'Establecer en {count} documentos',
  'inbox.bulkPaymentDone': 'Origen de pago establecido en {count} documentos.',
  'inbox.uploadPaymentSingleTitle': 'Pagado desde',
  'inbox.uploadPaymentBulkTitle': 'Asignar orígenes de pago',
  'inbox.uploadPaymentAppliesTo': 'Se aplica a {count} recibos seleccionados',
  'inbox.uploadPaymentSelectFirst': 'Selecciona recibos abajo y los botones les asignan el origen de pago.',
  'inbox.uploadPaymentBank': 'Banco',
  'inbox.uploadPaymentBankSetup': 'Añade primero una cuenta bancaria',
  'inbox.uploadPaymentOtherSource': 'Elegir otro origen de pago ...',
  'inbox.uploadPaymentOperating': 'Cuenta operativa',
  'inbox.uploadPaymentPrivate': 'Privado',
  'inbox.uploadPaymentPrivateRecommended': 'Recomendado sin cuenta de empresa',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analiza',
  'inbox.collectionNotice': 'Aviso de cobro',
  'inbox.collectionNoticeTitle': 'Esto pertenece al documento original',
  'inbox.collectionNoticeBody': 'No contabilices de nuevo el principal ni su IVA. Vincula el aviso al documento original; trata los intereses y los costes de cobro por separado y sin IVA.',
  'inbox.collectionNoticePrincipal': 'Principal',
  'inbox.collectionNoticeInterest': 'Intereses',
  'inbox.collectionNoticeCosts': 'Costes de cobro',
  'inbox.collectionNoticeCandidates': 'Posibles documentos originales',
  'inbox.collectionNoticeLink': 'Vincular',
  'inbox.collectionNoticeLinked': 'El aviso de cobro está vinculado al documento original.',
  'inbox.collectionNoticeLinkFailed': 'No se pudo vincular el aviso de cobro al documento original.',
  'inbox.collectionNoticeOpenOriginal': 'Abrir documento original',
  'inbox.collectionNoticeNoCandidate': 'No se encontró ninguna coincidencia segura. Busca o sube la factura original antes de procesar el aviso.',
  'inbox.collectionNoticeBookBlocked': 'Vincula el documento original antes de procesar',
  'inbox.uploadPaymentAssigned': 'Cuenta {account}',
  'inbox.uploadPaymentUnpaid': 'Aún sin pagar',
  'inbox.uploadPaymentUnpaidHint': 'Para una factura de proveedor que debe seguir pendiente de pago hasta que se pague.',
  'inbox.uploadPaymentAnalyze': 'Dejar que Plumme encuentre el origen del pago',
  'inbox.uploadPaymentUnassigned': 'Sin asignar',
  'inbox.uploadPaymentSelectVisible': 'Seleccionar los mostrados',
  'inbox.uploadPaymentShowAll': 'Mostrar todos',
  'inbox.uploadPaymentShowPending': 'Mostrar solo los no asignados',
  'inbox.uploadPaymentProgress': '{completed} de {count} asignados',
  'inbox.uploadPaymentConfirm': 'Subir {count}',
  'inbox.uploadPaymentReceipt': 'Documento',
  'inbox.cardNudgeTitle': '{count} documentos no tienen origen de pago',
  'inbox.cardNudgeText': 'Registra tus tarjetas en las cuentas bancarias y Plumme reconoce el pago directamente a partir del recibo. El tipo de cuenta decide si el desembolso es de la empresa o privado.',
  'inbox.cardNudgeAction': 'Registrar tarjetas',
  'inbox.shortDescription': 'Descripción breve del justificante',
  'inbox.shrinkPreview': 'Reducir vista previa',
  'inbox.growPreview': 'Ampliar vista previa',
  'inbox.dragWidth': 'Arrastra para cambiar el ancho',
  'inbox.sendTo': 'Enviar a:',
  'inbox.filterStatus': 'Estado',
  'inbox.filterBankConnection': 'Conexión bancaria',
  'inbox.filterReadyToPost': 'Listo para contabilizar',
  'inbox.filterNeedsReview': 'Requiere revisión',
  'inbox.filterAwaitingAnalysis': 'En espera de análisis',
  'inbox.toInbox': 'A la bandeja de entrada (justificantes)',
  'inbox.toDocumentation': 'A documentación',
  'inbox.selectAll': 'Seleccionar todo',
  'inbox.selectHint': 'Haz clic con Mayús para seleccionar un rango',
  'inbox.reviewSelected': 'Empezar a contabilizar ({count})',
  'inbox.planTitle': 'Contabilizar con SuperPlumma',
  'inbox.planLead': 'Se contabilizarán ahora {count} de los {selected} documentos seleccionados.',
  'inbox.planNothing': 'Ninguno de los documentos seleccionados se puede contabilizar tal como está.',
  'inbox.planWithNotes': '{count} con un origen de pago preseleccionado',
  'inbox.planConfirm': 'Contabilizar {count} documentos',
  'inbox.planShow': 'Mostrar',
  'inbox.planHide': 'Ocultar',
  'inbox.planSameFile': 'Bloqueado: el mismo archivo exacto ya está aquí ({count})',
  'inbox.planSameInvoiceNumber': 'Bloqueado: el número de factura ya está registrado ({count})',
  'inbox.planSameContent': 'Omitido: posible subida duplicada ({count})',
  'inbox.planNeedsReview': 'Omitido: requiere revisión ({count})',
  'inbox.planMissingData': 'Omitido: faltan datos ({count})',
  'inbox.planMissing': 'Omitido: ya no está en la bandeja de entrada ({count})',
  'inbox.planAllowContent': 'Contabilizarlos de todos modos: he comprobado que son compras distintas',
  'inbox.planAllowContentWarn': 'Los duplicados se contabilizarán como documentos separados. Compruébalo antes de continuar.',
  'inbox.planResultTitle': 'Contabilización terminada',
  'inbox.planResultLead': 'Se contabilizaron {booked} de los {selected} documentos seleccionados.',
  'inbox.planBooked': 'Contabilizados ({count})',
  'inbox.planSkipped': 'Omitidos ({count})',
  'inbox.planFailed': 'Fallidos ({count})',
  'inbox.walkTitle': 'Contabilizar documentos',
  'inbox.walkLead': '{count} documentos en la cola.',
  'inbox.walkReady': 'Listos',
  'inbox.walkNeedsReview': 'Requieren revisión',
  'inbox.walkDuplicates': 'Posibles duplicados',
  'inbox.walkDuplicateOf': 'Igual que {names}.',
  'inbox.walkHint': 'Puedes cerrar en cualquier momento: lo que no hayas tratado seguirá seleccionado.',
  'inbox.walkStart': 'Revisar los {count}',
  'inbox.walkBookReady': 'Contabilizar ahora los {count} listos',
  'inbox.walkPosition': '{index} de {total}',
  'inbox.walkPause': 'Continuar más tarde',
  'inbox.walkTrash': 'A la papelera',
  'inbox.walkSkip': 'Omitir',
  'inbox.walkNext': 'Siguiente',
  'inbox.walkGone': 'El documento ya no está',
  'inbox.walkGoneText': 'Se contabilizó, eliminó o movió mientras la revisión estaba abierta.',
  'inbox.walkDoneTitle': 'Revisión terminada',
  'inbox.walkDoneLead': '{count} documentos revisados',
  'inbox.walkDoneCounts': '{booked} contabilizados, {skipped} omitidos, {trashed} movidos a la papelera.',
  'inbox.clearSelection': 'Borrar selección',
  'inbox.restoreAll': 'Restaurar todo',
  'inbox.deletePermanently': 'Eliminar definitivamente',
  'inbox.deleteAll': 'Eliminar todo',
  'inbox.downloadAll': 'Descargar seleccionados',
  'inbox.downloading': 'Descargando...',
  'inbox.postAllWithAi': 'Contabilizar todo con SuperPlumma',
  'inbox.postWithAi': 'Contabilizar {count} con SuperPlumma',
  'inbox.postNoneReady': 'Ninguno de los documentos seleccionados está listo para contabilizar. Usa «Start posting» para tratarlos uno por uno.',
  'inbox.uploadDocument': 'Subir documento',
  'inbox.mergeToOne': 'Combinar en un solo justificante',
  'inbox.dragToMerge': 'Arrastra para combinar justificantes',
  'inbox.restore': 'Restaurar',
  'inbox.post': 'Contabilizar',
  'inbox.archiveNote': 'Un archivo para documentos que no deben contabilizarse como justificantes.',
  'inbox.searchDocs': 'Buscar documentos...',
  'inbox.moveToTrash': 'Mover a la papelera',
  'inbox.defaultVoucherName': 'Justificante',
  'inbox.defaultDocumentName': 'Documento',
  'inbox.docTypeSettlement': 'Liquidación',
  'inbox.docTypeSupplierInvoice': 'Factura de proveedor',
  'inbox.docTypeSaleVoucher': 'Justificante de venta',
  'inbox.docTypePurchaseVoucher': 'Justificante de compra',
  'inbox.paySourcePrivate': 'Pagado de forma privada',
  'inbox.paySourceCash': 'Efectivo',
  'inbox.paySourceUnclear': 'Pago poco claro',
  'inbox.paySourceCompany': 'Cuenta de la empresa',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % de IVA en el justificante · {deductionRate} % de deducción',
  'inbox.vatRateLabel': '{rate} % de IVA',
  'inbox.paidFromBank': 'Pagado desde el banco',
  'inbox.supplierNotRead': 'Proveedor no leído',
  'inbox.invoiceNumberLabel': 'Factura {number}',
  'inbox.attachmentLinkMissing': 'El adjunto no tiene un enlace disponible.',
  'inbox.menuNewPurchase': 'Compra pagada',
  'inbox.menuFixedAsset': 'Activo fijo',
  'inbox.menuOtherSale': 'Otra venta',
  'inbox.menuOpenAttachment': 'Abrir adjunto',
  'inbox.menuDownload': 'Descargar',
  'inbox.menuSplitAgain': 'Dividir de nuevo',
  'inbox.reanalyze': 'Volver a analizar',
  'inbox.analyze': 'Analizar',
  'inbox.previewDocumentFallback': 'Documento',
  'inbox.previewMissingFileLink': 'Falta el enlace del archivo',
  'inbox.saveNotConnected': 'El guardado de la sugerencia de justificante no está conectado al backend.',
  'inbox.suggestionUpdated': 'La sugerencia de justificante se ha actualizado.',
  'inbox.suggestionSaveFailed': 'No se pudo guardar la sugerencia de justificante.',
  'inbox.settlementFromLabel': 'Liquidación de',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'ID de liquidación',
  'inbox.settlementNetToBankLabel': 'Neto al banco',
  'inbox.suggestedInvoiceSingular': 'Factura sugerida',
  'inbox.suggestedInvoicePlural': 'Varias facturas posibles',
  'inbox.selectInvoiceManually': 'Elegir factura manualmente',
  'inbox.paidToggleOn': 'Pagada',
  'inbox.paidToggleOff': 'Sin pagar: se registra como cuenta por pagar',
  'inbox.paidToLabel': 'Pagado a',
  'inbox.projectSaveFailed': 'No se pudo guardar el proyecto.',
  'inbox.awaitingOcrData': 'En espera de datos OCR',
  'inbox.showSuggestionAgain': 'Mostrar la sugerencia de nuevo',
  'inbox.maximizePreview': 'Maximizar vista previa',
  'inbox.uploadPartialAnalyzing': 'Se subieron {done} de {total} justificantes. Analizando los que han llegado ...',
  'inbox.uploadedSingle': 'Justificante subido.',
  'inbox.uploadedMultipleAnalyzing': '{count} justificantes subidos. Analizando ...',
  'inbox.uploadFailedSingle': 'No se pudo subir el justificante.',
  'inbox.uploadFailedMultiple': 'No se pudieron subir los justificantes.',
  'inbox.uploadFailedGeneric': 'No se pudieron subir los justificantes.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} justificantes quedan como "En espera de análisis".',
  'inbox.uploadedButAnalysisFailedSingle': 'El justificante se subió, pero el análisis falló.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Los justificantes se subieron, pero el análisis falló.',
  'inbox.partialAnalysisFailed': 'No se analizaron {failed} de {total} justificantes. Prueba "Analizar" en la fila.',
  'inbox.documentAddedSingle': 'Documento añadido a Documentación.',
  'inbox.documentAddedMultiple': 'Documentos añadidos a Documentación.',
  'inbox.documentUploadFailed': 'No se pudo subir el documento.',
  'inbox.analyzed': 'El justificante se ha analizado.',
  'inbox.analyzeActionFailed': 'El análisis del justificante falló.',
  'inbox.bookedNoneReason': 'No se contabilizó ningún justificante.',
  'inbox.bookedSummary': '{booked} contabilizados, {skipped} omitidos.',
  'inbox.bookedOne': 'El justificante se ha contabilizado.',
  'inbox.bookedCount': '{count} justificantes contabilizados.',
  'inbox.bookFailedFallback': 'No se pudieron contabilizar los justificantes.',
  'inbox.setPaymentSourceFailed': 'No se pudo establecer el origen del pago.',
  'inbox.moveToTrashFailed': 'No se pudo mover el justificante o los justificantes a la papelera.',
  'inbox.movedToTrash': 'Justificante movido a la papelera.',
  'inbox.movedToTrashCount': '{count} justificantes movidos a la papelera.',
  'inbox.restoredOne': 'Justificante restaurado.',
  'inbox.restoredCount': '{count} justificantes restaurados.',
  'inbox.restoreFailed': 'No se pudo restaurar el justificante o los justificantes.',
  'inbox.confirmDeletePermanentOne': '¿Eliminar el justificante definitivamente?',
  'inbox.confirmDeletePermanentMany': '¿Eliminar definitivamente los justificantes seleccionados?',
  'inbox.deletedPermanently': 'Justificante eliminado definitivamente.',
  'inbox.deleteFailed': 'No se pudo eliminar el justificante o los justificantes.',
  'inbox.docMovedToTrash': 'Documento movido a la papelera.',
  'inbox.docMovedToTrashCount': '{count} documentos movidos a la papelera.',
  'inbox.docMoveToTrashFailed': 'No se pudo mover el documento o los documentos a la papelera.',
  'inbox.docRestored': 'Documento restaurado.',
  'inbox.docRestoredCount': '{count} documentos restaurados.',
  'inbox.docRestoreFailed': 'No se pudo restaurar el documento o los documentos.',
  'inbox.confirmDeleteDocOne': '¿Eliminar el documento definitivamente?',
  'inbox.confirmDeleteDocMany': '¿Eliminar definitivamente los documentos seleccionados?',
  'inbox.docDeletedPermanently': 'Documento eliminado definitivamente.',
  'inbox.docDeleteFailed': 'No se pudo eliminar el documento o los documentos.',
  'inbox.downloadPartial': 'Se descargaron {downloaded} de {total} archivos. No se pudo recuperar el resto.',
  'inbox.downloadedZip': '{count} archivos descargados en un zip.',
  'inbox.downloadedSingleFile': 'El archivo se ha descargado.',
  'inbox.downloadFilesFailed': 'No se pudieron descargar los archivos.',
  'inbox.movedToDocs': 'Justificante movido a Documentación.',
  'inbox.movedToDocsCount': '{count} justificantes movidos a Documentación.',
  'inbox.moveToDocsFailed': 'No se pudo mover el justificante o los justificantes a Documentación.',
  'inbox.mergedCount': '{count} justificantes combinados.',
  'inbox.mergeFailed': 'No se pudieron combinar los justificantes.',
  'inbox.splitAgainDone': 'El justificante se ha dividido de nuevo.',
  'inbox.splitAgainFailed': 'No se pudo dividir el justificante.',
  'inbox.addressCopied': 'Dirección del justificante copiada.',
  'inbox.trashTitle': 'Papelera',
  'inbox.docsSubtitle': 'Archivo de acuerdos, contratos y documentos que no son justificantes para contabilizar.',
  'inbox.inboxSubtitle': 'Sube justificantes o reenvíalos por correo electrónico: leemos lo que podamos.',
  'inbox.titleHelp': 'La bandeja de entrada es donde llegan los justificantes antes de contabilizarse. Sube archivos o reenvía recibos y facturas por correo electrónico: SuperPlumma lee el contenido y los deja listos para contabilizar.',
  'inbox.docsWithCount': 'Documentación ({count})',
  'inbox.trashWithCount': 'Papelera ({count})'
});
